import { Component, createRef } from "react";
import HeaderSistema from "./components/HeaderSistema";
import { Button } from "primereact/button";
import { Toast } from "primereact/toast";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { TabPanel, TabView } from "primereact/tabview";

import Pessoa from "lirida-back-service/Servicos/Pessoa/Pessoa";
import PessoaService from "lirida-back-service/Servicos/Pessoa/PessoaService";
import Endereco from "lirida-back-service/Servicos/Endereco/Endereco";
import GoogleAPI from 'lirida-back-service/Servicos/Google/GoogleAPI';
import Relacionamento from 'lirida-back-service/Servicos/PessoaRelacionamento/PessoaRelacionamento'
import Constante from "../../util/Constante";
import Util from "../../util/Util";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";




export default class CondominioDetalhe extends Component {
  constante = new Constante();
  toast = createRef();
  inputRef = createRef();
  util = new Util();
  googleApi = new GoogleAPI(this.constante.token, this.constante.url_base);
  pessoaService = new PessoaService(this.constante.token, this.constante.url_base);

  state = {
    pessoaUsuario: new Pessoa(),
    pessoaCondominio: new Pessoa(),
    endereco: new Endereco(),
    relacionamentoFranquia: new Relacionamento(),
    franquiaDeletar: new Relacionamento(),
    conteudo: '',
    urlBase: '',
    base64: '',
    emailFranquia: '',
    pesquisaEnderecoVisivel: false,

    inputError: {
      nome: false,
      email: false,
      telefone: false,
      endereco: false,
      franquia: false
    },
    //listas
    listaEndereco: [],
    listaFranquiados: [],
    //modals
    vModalFranquia: false,
    vModalDeletarFranquia: false,

  }
  componentDidMount() {
    this.iniciar();
  }

  async iniciar() {
    let urlBase = await this.util.buscarUrlBaseArquivo();
    let pessoaUsuario = await this.util.buscarLocalStorage("PESSOA_USUARIO");
    let parametro = this.util.buscarParametros();
    let retorno = await this.pessoaService.buscarPorSeqPessoa(parametro.id)
    let pessoaCondominio = retorno.objeto;
    let endereco = this.state.endereco
    let listaFranquiados = await this.listarFranquiados(pessoaCondominio)
    console.log(listaFranquiados)

    let retornoListaEndereco = await this.pessoaService.listarEndereco(pessoaCondominio);
    let listaEndereco = retornoListaEndereco.objeto;

    listaEndereco.forEach(pEndereco => {
      if (pEndereco._seqEndereco === pessoaCondominio.seqEnderecoPrincipal) {
        endereco = pEndereco;
      }
    });

    this.setState({
      pessoaUsuario: pessoaUsuario,
      pessoaCondominio: pessoaCondominio,
      conteudo: pessoaCondominio.tags0,
      endereco: endereco,
      urlBase: urlBase,
      listaFranquiados: listaFranquiados
    })
  }

  async salvar(pPessoa) {
    let endereco = this.state.endereco;
    let inputError = this.state.inputError;
    let inputOK = true;
    let pessoaCondominio = pPessoa;

    if (!pessoaCondominio) {
      pessoaCondominio = this.state.pessoaCondominio;
    }

    Object.keys(inputError).forEach(pKey => inputError[pKey] = false);

    if (!pessoaCondominio.nome) {
      inputError.nome = true;
    }

    if (!pessoaCondominio.emailPlataformaLirida) {
      inputError.email = true;
    }

    if (!pessoaCondominio.telefonePlataformaLirida) {
      inputError.telefone = true;
    }


    if (!pessoaCondominio.tags0) {
      inputError.endereco = true;
    }

    Object.keys(inputError).forEach(pKey => {
      if (inputError[pKey] === true) {
        inputOK = false;
      }
    });

    if (!inputOK) {
      this.setState({ inputError: inputError });
      return;
    }

    this.setState({ carregando: true });

    pessoaCondominio.seqUsuario = this.constante.seqUsuario;
    pessoaCondominio.seqPessoaPerfil = this.constante.seqPessoaPerfilCondominio;
    pessoaCondominio.situacao = "ATIVO";
    pessoaCondominio.seqTabelaPreco = this.constante.seqTabelaPrecoPadrao;

    if (this.state.base64) {
      pessoaCondominio.foto = this.state.base64;

      this.inputRef.current.value = '';
    }

    let retornoPessoa = await this.pessoaService.salvar(pessoaCondominio);
    pessoaCondominio = retornoPessoa.objeto;

    console.log(pessoaCondominio);

    endereco.seqUsuario = this.constante.seqUsuario;
    endereco.seqPessoa = pessoaCondominio._seqPessoa;

    let retornoEndereco = await this.pessoaService.salvarEndereco(endereco);
    endereco = retornoEndereco.objeto;

    pessoaCondominio.seqEnderecoPrincipal = endereco._seqEndereco;


    await this.pessoaService.salvar(pessoaCondominio);

    this.toast.current.show([
      { severity: 'success', summary: 'Informações armazenadas com sucesso!' },
    ]);

    this.setState({
      pessoaCondominio: pessoaCondominio,
      carregando: false,
    });


  }

  async salvarFranquia() {
    let emailFranquia = this.state.emailFranquia
    let relacionamentoFranquia = this.state.relacionamentoFranquia
    let pessoaCondominio = this.state.pessoaCondominio

    let retornoFranquia = await this.pessoaService.buscarPorEmail(emailFranquia, this.constante.seqUsuario)

    if (retornoFranquia.resultado === false) {
      this.toast.current.show([
        { severity: 'error', summary: retornoFranquia.msg },
      ]);
      return
    }

    let franquia = retornoFranquia.objeto

    if (franquia.seqPessoaPerfil !== this.constante.seqPessoaPerfilLider) {
      this.toast.current.show([
        { severity: 'error', summary: 'Profissional não pode se tornar um franquiado pois não é um líder' },
      ]);
      return
    }

    let listaFranquiados = this.state.listaFranquiados

    for (let i = 0; i < listaFranquiados.length; i++) {
      if (listaFranquiados[i].seqPessoaRelacionada === franquia._seqPessoa) {
        this.toast.current.show([
          { severity: 'error', summary: 'Profissional já é um franquiado' },
        ]);
      }
      return;

    }

    relacionamentoFranquia.seqUsuario = this.constante.seqUsuario;
    relacionamentoFranquia.seqPessoa = pessoaCondominio._seqPessoa;
    relacionamentoFranquia.seqPessoaRelacionada = franquia._seqPessoa;
    relacionamentoFranquia.seqTipoRelacionamento = this.constante.seqTipoRelacionamentoFranquia;
    relacionamentoFranquia.situacao = 'ATIVO';

    let retorno = await this.pessoaService.salvarRelacionamento(relacionamentoFranquia)
    relacionamentoFranquia = retorno.objeto

    this.toast.current.show([
      { severity: 'success', summary: "Franquia salva com sucesso!!" },
    ]);

    this.listarFranquiados(pessoaCondominio)

  }

  async listarFranquiados(pPessoaCondominio) {
    let pessoaCondominio = pPessoaCondominio

    let retorno = await this.pessoaService.listarRelacionamento(pessoaCondominio)
    let listaFranquiados = retorno.objeto

    this.setState({ listaFranquiados: listaFranquiados })

    return listaFranquiados;

  }

  async listarEndereco(pTexto) {
    if (pTexto.length < 3) return;

    let retornoListaEndereco = await this.googleApi.listarEndereco(pTexto);
    this.setState({ listaEndereco: retornoListaEndereco.predictions });
  }

  async buscarEndereco(pEndereco) {
    let retornoEndereco = await this.googleApi.buscarEndereco(pEndereco.place_id);
    let endereco = this.state.endereco;

    retornoEndereco.result.address_components.forEach(pEndereco => {
      if (pEndereco.types.includes("street_number")) {
        endereco.numero = pEndereco.long_name;
      }
      if (pEndereco.types.includes("route")) {
        endereco.logradouro = pEndereco.long_name;
      }
      if (pEndereco.types.includes("sublocality_level_1")) {
        endereco.bairro = pEndereco.long_name;
      }
      if (pEndereco.types.includes("administrative_area_level_2")) {
        endereco.cidade = pEndereco.long_name;
      }
      if (pEndereco.types.includes("administrative_area_level_1")) {
        endereco.estado = pEndereco.long_name;
        endereco.uf = pEndereco.short_name;
      }
      if (pEndereco.types.includes("country")) {
        endereco.pais = pEndereco.long_name;
      }
      if (pEndereco.types.includes("postal_code")) {
        endereco.cep = pEndereco.long_name;
      }
    });

    endereco.latitude = retornoEndereco.result.geometry.location.lat;
    endereco.longitude = retornoEndereco.result.geometry.location.lng;

    console.log(endereco);

    this.setState({
      endereco: endereco,
      pesquisaEnderecoVisivel: false,
      listaEndereco: [],
      conteudo: pEndereco.description,
      pessoaCondominio: {
        ...this.state.pessoaCondominio,
        tags0: pEndereco.description,
        latitude: endereco.latitude,
        longitude: endereco.longitude,
      }
    });
  }

  async selecionarArquivo(pArquivo) {
    let base64 = await this.util.pegarBase64(pArquivo);

    this.setState({ base64: base64 });
  }

  async deletarFranquia() {
    let franquiaDeletar = this.state.franquiaDeletar

    await this.pessoaService.deletarRelacionamento(franquiaDeletar)

    this.toast.current.show([
      { severity: 'success', summary: 'Franquia deletada com sucesso!!' },
    ]);

    this.listarFranquiados(this.state.pessoaCondominio)

  }

  render() {
    return <div>
      <HeaderSistema />
      <main style={{ width: "98%", margin: "20px auto" }}>
        <Toast ref={this.toast} />
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 20,
            border: "1px solid lightgray",
            padding: 20,
            borderRadius: 3,
            justifyContent: "space-between"
          }}
        >
          <div style={{ display: "flex", gap: 10 }}>
            <Button
              style={{ backgroundColor: this.constante.corPrincipal, borderColor: this.constante.corPrincipal }}
              onClick={() => window.location.href = '/sistema/condominio'}
              icon='pi pi-arrow-left'
            />
            <div>
              <h1 style={{ fontSize: 22, margin: 0 }}>Condomínio detalhe</h1>
              <h2 style={{ fontSize: 20, color: 'gray', margin: 0 }}>Condomínio detalhe</h2>
            </div>
          </div>

          <Button
            style={{ backgroundColor: this.constante.corPrincipal, bordercolor: this.constante.corPrincipal }}
            loading={this.state.carregando}
            label="Salvar"
            onClick={() => this.salvar()}
          />
        </div>
        {/* SALVAR FRANQUIA */}
        <Dialog header="Alerta" visible={this.state.vModalFranquia} style={{ width: 400 }} onHide={() => this.setState({ vModalFranquia: false, })}>
          <div style={{ display: "flex", flexDirection: 'column', gap: 20 }}>
            <p>Deseja realmente que o profissional <strong>{this.state.emailFranquia}</strong> faça parte da franquia?</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: "right" }}>
              <Button label="Sim" onClick={() => {
                this.salvarFranquia();
                this.setState({ vModalFranquia: false, });
              }} />
              <Button label="Não" onClick={() => this.setState({ vModalFranquia: false, })} />
            </div>
          </div>
        </Dialog>

        {/* DELETAR RELACIONAMENTO FRANQUIA */}
        <Dialog header="Alerta" visible={this.state.vModalDeletarFranquia} style={{ width: 400 }} onHide={() => this.setState({ vModalDeletarFranquia: false, })}>
          <div style={{ display: "flex", flexDirection: 'column', gap: 20 }}>
            <p>Deseja realmente deletar o relacionamento com essa franquia ?</p>
            <div style={{ display: 'flex', gap: 10, justifyContent: "right" }}>
              <Button label="Sim" onClick={() => {
                this.deletarFranquia();
                this.setState({ vModalDeletarFranquia: false, });
              }} />
              <Button label="Não" onClick={() => this.setState({ vModalDeletarFranquia: false, })} />
            </div>
          </div>
        </Dialog>


        <div style={{ display: "flex", alignItems: "center", gap: 5, marginTop: 10 }}>
          <i style={{ color: this.constante.corPrincipal, fontSize: '1rem', padding: 8, borderRadius: 360, border: `1px solid ${this.constante.corPrincipal}` }} className="pi pi-home" />
          <h3>Dados do condomínio</h3>
        </div>
        {/* DADOS CONDOMINIO */}
        <div style={{ border: '1px solid lightgray', padding: '20px 10px', borderRadius: 3, marginTop: 20, gap: 20 }}>
          <div style={{ display: "flex", alignItems: 'center', gap: 20 }}>
            <img
              style={{ width: 150, height: 150, objectFit: 'contain' }}
              alt='Foto'
              src={this.state.pessoaCondominio?.foto ? this.state.urlBase + this.state.pessoaCondominio?.foto : "https://resizedimgs.zapimoveis.com.br/crop/420x236/named.images.sp/bb907528bb4ce2df564a91a40878a7a6/terreno-lote-condominio-para-venda-ou-aluguel-102m-no-vila-prudente-sao-paulo.jpg"}
            />

            <InputText
              ref={this.inputRef}
              type="file"
              id="imagem_parceiro"
              onChange={pEvento => this.selecionarArquivo(pEvento.target.files[0])} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: "1fr 1fr 1fr", marginTop: 20, gap: 20 }}>
            <div>
              <label>Nome</label><br />
              <InputText
                style={{ width: '100%', borderColor: this.state.inputError.nome && 'red' }}
                onChange={pEvento => this.setState({
                  pessoaCondominio: {
                    ...this.state.pessoaCondominio,
                    nome: pEvento.target.value
                  }
                })}
                value={this.state.pessoaCondominio.nome || ""}
              />
              {this.state.inputError.nome && <small style={{ color: 'red' }}>Nome inválido</small>}
            </div>
            <div>
              <label>Email</label><br />
              <InputText
                style={{ width: '100%', borderColor: this.state.inputError.email && 'red' }}
                onChange={pEvento => this.setState({
                  pessoaCondominio: {
                    ...this.state.pessoaCondominio,
                    emailPlataformaLirida: pEvento.target.value
                  }
                })}
                value={this.state.pessoaCondominio.emailPlataformaLirida || ""}
              />
              {this.state.inputError.email && <small style={{ color: 'red' }}>Email inválido</small>}

            </div>
            <div>
              <label>Telefone</label><br />
              <InputText
                style={{ width: '100%', borderColor: this.state.inputError.telefone && 'red' }}
                type="tel"
                onChange={pEvento => this.setState({
                  pessoa: {
                    ...this.state.pessoaCondominio,
                    telefonePlataformaLirida: this.util.formatarTelefone(pEvento.target.value)
                  }
                })}
                value={this.state.pessoaCondominio.telefonePlataformaLirida || ""}
              />
              {this.state.inputError.telefone && <small style={{ color: 'red' }}>Telefone inválido</small>}

            </div>
          </div>

          <div style={{ width: "100%", marginTop: 20 }}>
            <label>Endereço</label><br />
            <div>
              <span className="p-input-icon-left" style={{ width: '100%' }}>
                {!this.state.pesquisaEnderecoVisivel && this.state.endereco.logradouro ?
                  <i className="pi pi-check" />
                  :
                  <i className="pi pi-search" />
                }
                <InputText
                  style={{ width: '100%', borderColor: this.state.inputError.endereco && 'red', marginTop: 5 }}
                  onChange={pEvento => {
                    this.setState({
                      conteudo: pEvento.target.value,
                      pesquisaEnderecoVisivel: true
                    });
                    this.listarEndereco(pEvento.target.value)
                  }}
                  value={this.state.conteudo || ""} />
              </span>
              {this.state.inputError.endereco && <small style={{ color: 'red' }}>Endereço inválido</small>}
            </div>
          </div>

          {this.state.listaEndereco.map(pEndereco =>
            <Button
              type="button"
              key={Math.random()}
              label={pEndereco.description}
              className="p-button-link"
              style={{ width: "100%", textAlign: 'left', marginTop: 10 }}
              onClick={() => this.buscarEndereco(pEndereco)} />
          )}
        </div>
        {/* FIM DADOS CONDOMÍNIO */}


        <div style={{ border: '1px solid lightgray', padding: 10, borderRadius: 3, marginTop: 20 }}>
          <TabView style={{ marginTop: 10 }}>
            <TabPanel header="Franquia" >
              <div style={{
                widht: 'auto',
                display: 'flex',
                gap: 20,
                margin: '10px 0 40px 0',
                alignItems: "center"
              }}>
                <div>
                  <label>Email</label><br />
                  <InputText
                    style={{ width: '100%' }}
                    onChange={pEvento => this.setState({ emailFranquia: pEvento.target.value })}
                    value={this.state.emailFranquia || ""}
                  />

                </div>
                <Button
                  type="button"
                  label='Buscar'
                  disabled={!this.state.emailFranquia}
                  loading={this.state.carregando}
                  style={{ width: "9%", height: 45, textAlign: 'left', marginTop: 15, backgroundColor: this.constante.corPrincipal, BODERcOLOR: this.constante.corPrincipal }}
                  onClick={() => this.setState({ vModalFranquia: true })}
                />
              </div>

              <DataTable
                showGridlines
                removableSort
                paginator
                responsiveLayout="scroll"
                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords}"
                rows={50}
                rowsPerPageOptions={[50, 60, 70, 80, 100]}
                style={{ width: "100%", marginTop: 30 }}
                value={this.state.listaFranquiados}
                loading={this.state.carregando}
              >
                <Column
                  header="Nome"
                  field="_pessoaRelacionadaNome"
                  sortable />

                <Column
                  header="Tipo de relacionamento"
                  field="_tipoRelacionamentoNome"
                  sortable />

                <Column
                  header="Data cadastro"
                  field="dataCadastro"
                  body={item => this.util.formatarData(item.dataCadastro)}
                  sortable />

                <Column
                  header="Deletar"
                  field="dataCadastro"
                  body={item => <div style={{ display: "flex", justifyContent: "center", widht: "100%" }}>
                    <Button
                      icon="pi pi-trash"
                      onClick={() => this.setState({ vModalDeletarFranquia: true, franquiaDeletar: item })} />
                  </div>}
                  sortable />


              </DataTable>
            </TabPanel>
          </TabView>
        </div>
      </main>
    </div>
  }
}